// This file is generated. Modify the build script if you need to change it.

package dev.bitspittle.droidconSf24.components.sections

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.Section
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.toAttrs
@Composable
fun Slides() {
   dev.bitspittle.droidconSf24.pages.sections.intro.TitlePage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSitesPage()
       dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites1Page()
       dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites2Page()
       dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites3Page()
       dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites4Page()
       dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites5Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.intro.CautionPage()
   dev.bitspittle.droidconSf24.pages.sections.html.HeaderPage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.html.Html2ComposePage()
       dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose1Page()
       dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose2Page()
       dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose3Page()
       dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose4Page()
       dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose6Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.html.CMPvsComposeHtmlPage()
   dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.HeaderPage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobwebPage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb3Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb4Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb5Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb6Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ArchitecturePage()
   dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.InstallKobwebPage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCliPage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli3Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli4Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli5Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli6Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ModifierPage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier1Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier3Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier4Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier6Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier7Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.RoutingPage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing1Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing3Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing4Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing5Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing6Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing7Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing8Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing9Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing10Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing11Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContextPage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContext1Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContext2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContext3Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContext4Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganizationPage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization1Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization3Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization4Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization5Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization6Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization10Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.HeaderPage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.WidgetsPage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets1Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets4Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets6Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets7Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets8Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStylePage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle1Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle3Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle4Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle5Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle6Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle7Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle8Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.ColorModePage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.ColorMode1Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.ColorMode2Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.ResponsivePage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Responsive1Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.IconsPage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Icons1Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Icons2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Icons3Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.HeaderPage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.MarkdownPage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Markdown2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Markdown3Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Markdown4Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.FrontMatterPage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.CodePage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Code1Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Code2Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.HeaderPage()
   dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.FullstackVsStaticPage()
   dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.BuildScriptPage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoutePage()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute2Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute3Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute4Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute5Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute6Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute7Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute8Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute9Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute10Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute11Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute12Page()
       dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute13Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.conclusion.HeaderPage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.conclusion.RevealPage()
       dev.bitspittle.droidconSf24.pages.sections.conclusion.Reveal2Page()
       dev.bitspittle.droidconSf24.pages.sections.conclusion.Reveal3Page()
       dev.bitspittle.droidconSf24.pages.sections.conclusion.Reveal4Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.conclusion.RecapPage()
   Section {
       dev.bitspittle.droidconSf24.pages.sections.conclusion.AdditionalPage()
       dev.bitspittle.droidconSf24.pages.sections.conclusion.Additional2Page()
       dev.bitspittle.droidconSf24.pages.sections.conclusion.Additional3Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.conclusion.CommunityPage()
       dev.bitspittle.droidconSf24.pages.sections.conclusion.Community2Page()
       dev.bitspittle.droidconSf24.pages.sections.conclusion.Community3Page()
       dev.bitspittle.droidconSf24.pages.sections.conclusion.Community4Page()
   }
   Section {
       dev.bitspittle.droidconSf24.pages.sections.conclusion.ThankYouPage()
       dev.bitspittle.droidconSf24.pages.sections.conclusion.ThankYou2Page()
   }
   dev.bitspittle.droidconSf24.pages.sections.QandAPage()
}
